import React from 'react';
import { Box } from '@mui/material';
import bgImageSrc from '../img/bg_main_image.jpg'; // page background image
import logo from '../img/logo.webp';
import logoSmall from '../img/logo_small.svg';

// site logo
export const LogoBlock = ({ step }) => (
    <Box
        component="img"
        sx={{
            height: step > 2 ? '50px' : '90px',
            width: step > 2 ? '50px' : '98px',
            objectFit: 'contain',
            m: step > 2 ? '26px auto 46px' : '16px auto 17px'
        }}
        alt="Monad"
        src={step > 2 ? logoSmall : logo}
        loading="lazy"
    />
);
// Background image
export const BgImage = () => (
    <Box
        component="img"
        sx={{
            height: '100%',
            width: '100%',
            inset: 0,
            position: 'fixed',
            zIndex: '-1',
            objectFit: 'cover',
            objectPosition: 'center'
        }}
        alt="Monad Social"
        src={bgImageSrc}
        loading="lazy"
    />
);

